/**
 * @description: 开房小吃
 * @author: hwx
 */
<template>
	<div>
		<div class="commodity-snack" v-show="showList">
			<div class="row row-margin" v-if="list_menu_add">
				<button type="button" class="btn bg-orange btn-flat bigbtn" @click="addSnack">新增开房小吃</button>
			</div>
			<div class="row">
				<label class="list-label-2">门店:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="snack_shop"></select>
				</div>
				<label class="list-label-4">包厢类型:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="snack_boxtype"></select>
				</div>
				<label class="list-label-2">状态:</label>
				<div class="col-md-2 ct-col">
					<select class="select2" ref="snack_status">
						<option value=" ">全部</option>
						<option value="1">启用</option>
						<option value="-1">禁用</option>
					</select>
				</div>
				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="clkQuery">查询</button>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-hover" data-pagination="true" ref="snack_list">
				</table>
			</div>
		</div>


		<!-- 添加/修改 -->
		<div class="snack-edit" v-show="showEdit">
			<div class="page-tit">{{edit_tit}}</div>
			<div class="row">
				<label class="ctr-label-left">门店:</label>
				<div class="col-md-6 ct-col">
					<select class="form-control" ref="edit_shop"></select>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">优先级:</label>
				<div class="col-md-6">
					<input class="form-control" v-model="edit_priority" ref="edit_priority"
						placeholder="请输入规则优先级：例如01、02、03">
				</div>
				<span class="rmarkspan" titles="数值大的优先" @mouseenter="hint_language($event)"
					@mouseleave="close_hint_language"></span>
			</div>
			<div class="row">
				<label class="ctr-label-left">适用包厢：</label>
				<div class="col-md-6">
					<input class="form-control input-readonly" placeholder="请选择包厢号" v-model="edit_box" ref="edit_box"
						readonly @click="editBoxFun($event)">
					<span class="selection-clear" @click="clearInput('edit_box')">×</span>
					<span class="span-arrow"><b></b></span>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">包厢类型：</label>
				<div class="col-md-6">
					<input type="text" class="form-control input-readonly" placeholder="请选择包厢类型" v-model="edit_boxtype"
						ref="edit_boxtype" readonly @click="editBoxtypeFun($event)">
					<span class="selection-clear" @click="clearInput('edit_boxtype')">×</span>
					<span class="span-arrow"><b></b></span>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">使用时间:</label>
				<div class="col-md-6">
					<input class="form-control input-readonly" v-model="edit_use_time" ref="edit_use_time"
						placeholder="请选择使用时间" readonly="readonly" @click="useTimePop()">
					<span class="selection-clear" @click="clearInput('edit_use_time')">×</span>
					<span class="span-arrow"><b></b></span>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">有效星期几</label>
				<div class="col-md-6">
					<input type="text" class="form-control input-readonly" placeholder="请选择有效星期几"
						v-model="edit_week_txt" ref="edit_week_txt" readonly @click="editWeekFun($event)">
					<span class="selection-clear" @click="clearInput('edit_week_txt')">×</span>
					<span class="span-arrow"><b></b></span>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">开房类型</label>
				<div class="col-md-6">
					<input type="text" class="form-control input-readonly" placeholder="请选择开房类型"
						v-model="edit_oproom_txt" ref="edit_oproom_txt" readonly @click="editOproomFun($event)">
					<span class="selection-clear" @click="clearInput('edit_oproom_txt')">×</span>
					<span class="span-arrow"><b></b></span>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">免费小吃:</label>
				<div class="col-md-6">
					<input class="form-control input-readonly" placeholder="请选择自动售出免费开房小吃" v-model="edit_free"
						ref="edit_free" readonly @click="editFreeFun($event)">
					<span class="selection-clear" @click="clearInput('edit_free')">×</span>
					<span class="span-arrow"><b></b></span>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">收费小吃:</label>
				<div class="col-md-6">
					<input class="form-control input-readonly" placeholder="请选择自动售出收费开房小吃" v-model="edit_charge"
						ref="edit_charge" readonly @click="editChargeFun($event)">
					<span class="selection-clear" @click="clearInput('edit_charge')">×</span>
					<span class="span-arrow"><b></b></span>
				</div>
			</div>
			<div class="row">
				<button type="button" class="btn btn-middle btn-flat btn-border-gray" @click="backList">返回</button>
				<button type="button" class="btn btn-middle bg-orange btn-flat sub-margin" @click="saveEdit">确定</button>
			</div>

			<!--包厢类型弹窗-->
			<div class="ele-hide" ref="boxtype_alert">
				<div class="multi-select">
					<div class="clearfix">
						<li>
							<input type='checkbox' v-model='boxtype_all' @click='boxtypeAll'>
							<label>全选</label>
						</li>
					</div>
					<ul class="clearfix">
						<li v-for="item in boxtype_arr" :key="item.id">
							<input type="checkbox" v-model='boxtype_item' :value="item.id">
							<label>{{item.name}}</label>
						</li>
					</ul>
				</div>
			</div>
			<!-- 使用时间弹窗 -->
			<div class="use-time-wrap" ref="snack_use_time">
				<h2>开始时间：</h2>
				<select ref="starthour"></select>
				<label class="colon">:</label>
				<select ref="startseconds"></select>
				<h2>结束时间：</h2>
				<select ref="stophour"></select>
				<label class="colon">:</label>
				<select ref="stopseconds"></select>
			</div>
			<!-- 星期选择弹窗 -->
			<div class="ele-hide" ref="week_alert">
				<div class="multi-select">
					<div class="clearfix">
						<li>
							<input type='checkbox' v-model='week_all' @click='weekAll'>
							<label>全选</label>
						</li>
					</div>
					<ul class="clearfix">
						<li>
							<input type="checkbox" v-model='week_item' value="1">
							<label>星期一</label>
						</li>
						<li>
							<input type="checkbox" v-model='week_item' value="2">
							<label>星期二</label>
						</li>
						<li>
							<input type="checkbox" v-model='week_item' value="3">
							<label>星期三</label>
						</li>
						<li>
							<input type="checkbox" v-model='week_item' value="4">
							<label>星期四</label>
						</li>
						<li>
							<input type="checkbox" v-model='week_item' value="5">
							<label>星期五</label>
						</li>
						<li>
							<input type="checkbox" v-model='week_item' value="6">
							<label>星期六</label>
						</li>
						<li>
							<input type="checkbox" v-model='week_item' value="0">
							<label>星期日</label>
						</li>
					</ul>
				</div>
			</div>
			<!-- 开房类型弹窗 -->
			<div class="ele-hide" ref="oproom_alert">
				<div class="multi-select">
					<div class="clearfix">
						<li>
							<input type='checkbox' v-model='oproom_all' @click='oproomAll'>
							<label>全选</label>
						</li>
					</div>
					<ul class="clearfix">
						<li>
							<input type="checkbox" v-model='oproom_item' value="1">
							<label>计时开房</label>
						</li>
						<li>
							<input type="checkbox" v-model='oproom_item' value="2">
							<label>开房套餐</label>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- 免费小吃页 -->
		<div class="free-page" v-show="showFree">
			<div class="row">
				<div class="col-md-2">
					<button type="button" class="btn btn-flat btn-middle btn-orange" @click="saveFree">确定</button>
				</div>
				<div class="col-md-2">
					<button type="button" class="btn btn-flat btn-middle btn-orange" @click="addFreeGoods">添加商品</button>
				</div>
			</div>
			<div class="row free-page-txt">
				<h3>免费开房小吃选择</h3>
			</div>
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-hover" data-pagination="true" ref="free_goods">
				</table>
			</div>
		</div>
		<!-- 免费小吃商品弹窗 -->
		<div class="free-goods-alert" ref="free_goods_alert">
			<div class="row">
				<div class="col-md-3 ct-col clear-pd">
					<select class="form-control" data-placeholder="商品类型" ref="free_goods_type">
						<option value=""></option>
					</select>
				</div>
				<div class="col-md-6">
					<input type="text" class="form-control" placeholder="请输入商品名称" ref="free_goods_name"
						@keyup.13="queryFreeGoods" />
				</div>
				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="queryFreeGoods">查询</button>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="free_goods_list"></table>
			</div>
			<div class="row btns">
				<button type="button" class="btn btn-flat btn-small btn-orange" @click="saveFreeGoods"
					style="margin: 0 50px 0 180px;">保存</button>
				<button type="button" class="btn btn-flat btn-small btn-gray" @click="closelayer">取消</button>
			</div>
		</div>
		<!-- 收费小吃页 -->
		<div class="charge-page" v-show="showCharge">
			<div class="row">
				<div class="col-md-2">
					<button type="button" class="btn btn-flat btn-middle btn-orange" @click="saveCharge">确定</button>
				</div>
				<div class="col-md-2">
					<button type="button" class="btn btn-flat btn-middle btn-orange"
						@click="addChargeGoods">添加商品</button>
				</div>
			</div>
			<div class="row">
				<h3>收费开房小吃选择</h3>
				<p>注：单价为当前商品的优惠价，若设置了手动价格则该商品在开房小吃独立计价，原商品单价不生效，且手动价不支持会员打折优惠。</p>
			</div>
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-hover" data-pagination="true" ref="charge_goods">
				</table>
			</div>
		</div>
		<!-- 收费小吃商品弹窗 -->
		<div class="charge-goods-alert" ref="charge_goods_alert">
			<div class="row">
				<div class="col-md-3 ct-col clear-pd">
					<select class="form-control" data-placeholder="商品类型" ref="charge_goods_type">
						<option value=""></option>
					</select>
				</div>
				<div class="col-md-6">
					<input type="text" class="form-control" placeholder="请输入商品名称" ref="charge_goods_name"
						@keyup.13="queryChargeGoods" />
				</div>
				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-small btn-orange"
						@click="queryChargeGoods">查询</button>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="charge_goods_list"></table>
			</div>
			<div class="row btns">
				<button type="button" class="btn btn-flat btn-small btn-orange" id="pop-save" @click="saveChargeGoods"
					style="margin: 0 50px 0 180px;">保存</button>
				<button type="button" class="btn btn-flat btn-small btn-gray" id="pop-cancel"
					@click="closelayer">取消</button>
			</div>
		</div>
		<!-- 包厢号 -->
		<div class="multi-page snack-box-page" ref="box_area" v-show="showBox">
			<div class="page-tit">选择包厢</div>
			<ul class="snack-box-type clearfix">
				<li class="snack-box-sel" @click="boxTypeCg(1)">按包厢区域显示</li>
				<li @click="boxTypeCg(2)">按包厢类型显示</li>
			</ul>
			<p>请选择包厢范围</p>
			<div class="multi-page-main">
				<div class="multi-page-row">
					<div>
						<input type="checkbox" v-model='box_all' @click='boxAll'>
						<span>全部包厢</span>
					</div>
					<ul></ul>
				</div>
				<div class="multi-page-row" v-for="(items, index) in box_arr" :key="items.room_area">
					<div>
						<input type="checkbox" v-model='box_floor' :value="items.room_area"
							@click="boxFloor(items.room_area, index)">
						<span>{{items.room_area_name}}</span>
					</div>
					<ul class="clearfix">
						<li v-for="item in items.room" :key="item.id">
							<input type="checkbox" v-model='box_item' :value="item.id">
							<span>{{item.name}}</span>
						</li>
					</ul>
				</div>
			</div>
			<div class="row">
				<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="boxBackEdit()">返回</button>
				<button type="button" class="btn btn-flat btn-middle btn-orange sub-margin"
					@click="saveBox()">确定</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		data() {
			return {
				showList: true,
				showEdit: false,
				showDetail: false,
				showFree: false,
				showCharge: false,
				showBox: false,
				modify: 1,

				list_menu_add: false,
            	list_menu_op: [],
				edit_id: '',
				edit_tit: '新增开房小吃规则',
				edit_priority: '',
				edit_box: '',
				room_type: 1,
				c_room_type: 1,
				box_all: false,
				c_box_all: false,
				use_all_room: '',
				box_item: [],
				c_box_item: [],
				box_floor: [],
				c_box_floor: [],
				box_arr: [],
				box_arr_det: [],
				edit_boxtype: '',
				boxtype_all: false,
				c_boxtype_all: false,
				boxtype_item: [],
				boxtype_arr: [],
				time_start_time: '',
				time_end_time: '',
				edit_week_txt: '',
				week_all: false,
				c_week_all: false,
				week_item: [],
				week_arr: [{id: "1", name: "一"}, {id: "2", name: "二"}, {id: "3", name: "三"}, {id: "4", name: "四"}, {id: "5", name: "五"}, {id: "6", name: "六"}, {id: "0", name: "日"}],
				edit_oproom_txt: '',
				oproom_all: false,
				c_oproom_all: false,
				oproom_item: [],
				oproom_arr: [{id: "1", name: "计时开房"}, {id: "2", name: "套餐开房"}],
				edit_free: [],
				free_goods_arr: [],
				edit_charge: [],
				charge_goods_arr: [],

				goodsType_list: [],
				free_sign: '',
				free_sign_id: '',
				charge_sign: '',
				charge_sign_id: '',
			}
		},
		computed: {
			edit_use_time() {
				return this.time_start_time + "-" + this.time_end_time;
			}
		},
		watch: {
			edit_box: {
				handler: function(val, oldval) {
					if(val != "") {
						$(this.$refs.edit_box).parent().find('.selection-clear').show();
						$(this.$refs.edit_boxtype).prop("disabled", true);
					} else {
						$(this.$refs.edit_box).parent().find('.selection-clear').hide();
						$(this.$refs.edit_boxtype).prop("disabled", false);
					}
				},
				deep: true
			},
			box_item: {
				handler: function(val, oldVal) {
					let _this = this;

					if(_this.box_item.length >= _this.box_arr_det.length) {
						_this.box_all = true;
						_this.c_box_all = _this.box_all;
					} else {
						_this.box_all = false;
						_this.c_box_all = _this.box_all;
					}

					$.each(_this.box_arr, function(k, v) {
						if(_this.box_item.length >= v.room.length) {
							let num = 0;
							for(let i = 0, len = v.room.length; i < len; i++) {
								if(_this.box_item.indexOf(v.room[i].id) != -1) {
									num++;
								}
								if(i == v.room.length - 1 && num == v.room.length) {
									if(_this.box_floor.indexOf(v.room_area) == -1) {
										_this.box_floor.push(v.room_area);
									}
								} else {
									let index = '';
									index = _this.box_floor.indexOf(v.room_area);
									if(index != -1) {
										_this.box_floor.splice(index, 1);
									}
								}
							}
						} else {
							let index = '';
							index = _this.box_floor.indexOf(v.room_area);
							if(index != -1) {
								_this.box_floor.splice(index, 1);
							}
						}
					});
					_this.c_box_floor = _this.box_floor;
				},
				deep: true
			},
			edit_boxtype: {
				handler: function(val, oldval) {
					if(val != "") {
						$(this.$refs.edit_boxtype).parent().find('.selection-clear').show();
						$(this.$refs.edit_box).prop("disabled", true);
					} else {
						$(this.$refs.edit_boxtype).parent().find('.selection-clear').hide();
						$(this.$refs.edit_box).prop("disabled", false);
					}
				},
				deep: true
			},
			boxtype_item: {
				handler: function (val, oldVal) {
					if(this.boxtype_item.length >= this.boxtype_arr.length) {
						this.boxtype_all = true;
						this.c_boxtype_all = this.boxtype_all;
					} else {
						this.boxtype_all = false;
						this.c_boxtype_all = this.boxtype_all;
					}
				},
				deep: true
			},
			edit_use_time: {
				handler: function(val, oldval) {
					if(val != "-") {
						$(this.$refs.edit_use_time).parent().find('.selection-clear').show();
					} else {
						$(this.$refs.edit_use_time).parent().find('.selection-clear').hide();
					}
				},
				deep: true
			},
			edit_week_txt: {
				handler: function(val, oldval) {
					if(val != "") {
						$(this.$refs.edit_week_txt).parent().find('.selection-clear').show();
					} else {
						$(this.$refs.edit_week_txt).parent().find('.selection-clear').hide();
					}
				},
				deep: true
			},
			week_item: {
				handler: function (val, oldVal) {
					if(this.week_item.length >= this.week_arr.length) {
						this.week_all = true;
						this.c_week_all = true;
					} else {
						this.week_all = false;
						this.c_week_all = false;
					}
				},
				deep: true
			},
			edit_oproom_txt: {
				handler: function(val, oldval) {
					if(val != "") {
						$(this.$refs.edit_oproom_txt).parent().find('.selection-clear').show();
					} else {
						$(this.$refs.edit_oproom_txt).parent().find('.selection-clear').hide();
					}
				},
				deep: true
			},
			oproom_item: {
				handler: function (val, oldVal) {
					if(this.oproom_item.length >= this.oproom_arr.length) {
						this.oproom_all = true;
						this.c_oproom_all = true;
					} else {
						this.oproom_all = false;
						this.c_oproom_all = false;
					}
				},
				deep: true
			},
			edit_free: {
				handler: function(val, oldval) {
					if(val.length > "0") {
						$(this.$refs.edit_free).parent().find('.selection-clear').show();
					} else {
						$(this.$refs.edit_free).parent().find('.selection-clear').hide();
					}
				},
				deep: true
			},
			edit_charge: {
				handler: function(val, oldval) {
					if(val.length > "0") {
						$(this.$refs.edit_charge).parent().find('.selection-clear').show();
					} else {
						$(this.$refs.edit_charge).parent().find('.selection-clear').hide();
					}
				},
				deep: true
			},
		},
		mounted: function() {
			this.getMenuOp();
			this.getShopData();
			$(this.$refs.snack_status).select2({
				language: "zh-CN",
				minimumResultsForSearch: -1,
				width: '100%'
			});
			$(this.$refs.snack_status).val(1).trigger('change');

			this.$nextTick(function() {
				this.selectTime();
				this.getCusPakage();
			});
		},
		methods: {
			// 获取权限
			getMenuOp() {
				let _this = this,
					menu = [];
				if(!$.isEmptyObject(this.$store.state.menunew)) {
					menu = JSON.parse(this.$store.state.menunew);
					$.each(menu, function(k, v) {
						if(v.id == '542') {
							menu = v.submenu;
							$.each(menu, function(m, n) {
								if(n.id == '632') {
									menu = n.submenu;
								}
							});
						}
					});

					_this.list_menu_op = [{cls: 'text-blue status', name: '状态'}, {cls: 'text-blue detail', name: '详情'}];
					$.each(menu, function(x, y) {
						if(y.id == '930') {
							_this.list_menu_add = true;
						}
						if(y.id == '931') {
							_this.list_menu_op.push({cls: 'text-blue edit', name: '修改'});
						}
						if(y.id == '932') {
							_this.list_menu_op.push({cls: 'text-blue del', name: '删除'});
						}
					});
				}
			},
			// 页面提示语
			hint_language: function(e) {
				var contents="<span class='dots'>·</span>"+$(e.currentTarget).attr("titles");
				layer.tips(contents, (e.currentTarget), {
					skin: 'hint_language_tip',
					tips: [2, '#fff'],
					time: 2000000,
				});
			},
			// 关闭提示语
			close_hint_language: function() {
				layer.closeAll('tips');
			},
			// 清空
			clearInput: function(name) {
				if(name == "edit_box") {
					this.use_all_room = '-1';
					this.edit_box = '';
					this.box_item = [];
				} else if(name == "edit_boxtype") {
					this.edit_boxtype = '';
					this.boxtype_item = [];
				} else if(name == 'edit_use_time') {
					this.time_start_time = '';
					this.time_end_time = '';
				} else if(name == 'edit_week_txt') {
					this.edit_week_txt = '';
					this.week_item = [];
				} else if(name == 'edit_oproom_txt') {
					this.edit_oproom_txt = '';
					this.oproom_item = [];
				} else if(name == "edit_free") {
					this.edit_free = [];
					this.free_goods_arr = [];
					$(this.$refs.free_goods).bootstrapTable("destroy");
				} else if(name == "edit_charge") {
					this.edit_charge = [];
					this.charge_goods_arr = [];
					$(this.$refs.charge_goods).bootstrapTable("destroy");
				}
			},
			// 初始化商品类型
			getCusPakage() {
				const _this = this;

				_this.goodsType_list = [{
					id: "0",
					text: "全部"
				}, {
					id: "-2",
					text: "商品套餐",
					sign: '-2',
					sign_id: '0'
				}];
				Vue.axios.post('PublicData/api_getWaresType', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						res.data.response.result.data.forEach(v => {
							_this.goodsType_list.push({
								id: '-2' + v.id,
								text: v.name,
								sign: '-2',
								sign_id: v.id
							});
						});
						_this.initGoodsType();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			initGoodsType: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getGoodsType",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							$.each(data.response.result.data, function(k, v) {
								_this.goodsType_list.push({ id: v.id, text: v.name });
							});
							$(_this.$refs.free_goods_type).select2({
								data: _this.goodsType_list,
								width: '100%'
							}).on("select2:select", function(e) {
								_this.free_sign = e.params.data.sign;
								if(_this.free_sign == '-2') {
									_this.free_sign_id = e.params.data.sign_id;
									_this.initFreePackage($(_this.$refs.edit_shop).val());
								} else {
									_this.initFreeGoods($(_this.$refs.edit_shop).val());
								}
							});

							$(_this.$refs.charge_goods_type).select2({
								data: _this.goodsType_list,
								width: '100%'
							}).on("select2:select", function(e) {
								_this.charge_sign = e.params.data.sign;
								if(_this.charge_sign == '-2') {
									_this.charge_sign_id = e.params.data.sign_id;
									_this.initChargePackage($(_this.$refs.edit_shop).val());
								} else {
									_this.initChargeGoods($(_this.$refs.edit_shop).val());
								}
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},

			// 获取门店数据
			getShopData: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							let arr = [];
							$.each(data.response.result, function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							arr.shift();
							$(_this.$refs.snack_shop).select2({
								data: arr,
								language: "zh-CN"
							}).on("select2:select", function(e) {
								_this.getBoxtype(e.params.data.id);
							});
							$(_this.$refs.snack_shop).val("").trigger('change');
							_this.getBoxtype($(_this.$refs.snack_shop).val());
							_this.innitTable();

							$(_this.$refs.edit_shop).select2({
								data: arr,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							}).on("select2:select",function(e) {
								// 包厢
								_this.getBoxNum(e.params.data.id, '1');
								_this.edit_box = '全部包厢';
								_this.use_all_room = '1';
								_this.box_item = [];
								_this.box_arr_det.forEach(function(item) {
									_this.box_item.push(item.id);
								});
								// 包厢类型
								_this.edit_boxtype = '';
								_this.boxtype_item = [];
								_this.getBoxtype(e.params.data.id, 2);
								// 小吃
								_this.edit_free = [];
								_this.free_goods_arr = [];
								$(_this.$refs.free_goods).bootstrapTable("destroy");
								_this.edit_charge = [];
								_this.charge_goods_arr = [];
								$(_this.$refs.charge_goods).bootstrapTable("destroy");
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			// 包厢类型数据
			getBoxtype: function(shop_id, num) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getRoomType",
					crossDomain: true,
					async: false,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							if(num == 2) {
								_this.boxtype_arr = data.response.result.data;
								return;
							}
							let arr = [{ 'id': ' ', text: '全部' }];
							$.each(data.response.result.data, function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							$(_this.$refs.snack_boxtype).select2({
								data: arr,
								language: "zh-CN"
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			// 开房小吃列表
			innitTable: function() {
				let _this = this;
				$(_this.$refs.snack_list).bootstrapTable("destroy");
				$(_this.$refs.snack_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 10,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "listorder",
						title: "优先级",
						width: "5%"
					}, {
						field: "shop_name",
						title: "适用门店",
						width: "8%"
					}, {
						field: "room_info",
						title: "适用包厢",
						width: "15%",
						class: "room-info-td",
						formatter: function(value, row, index) {
							if(row.use_all_room == '1') {
								return '全部包厢'
							} else {
								return row.room_info
							}
						}
					}, {
						field: "room_type_info",
						title: "包厢类型",
						width: "9%"
					}, {
						field: "week_cycle_name",
						title: "有效星期几",
						width: "8%"
					}, {
						field: "start_time",
						title: "使用时间",
						width: "10%",
						formatter: function(value, row, index) {
							return row.start_time + ' - ' + row.end_time;
						}
					}, {
						field: "free_snack_info",
						title: "免费小吃",
						width: "11%"
					}, {
						field: "charge_snack_info",
						title: "收费小吃",
						width: "11%"
					}, {
						title: "操作",
						width: "12%",
						events: {
							'click .edit': function(e, value, row) {
								_this.modify = 2;
								_this.edit_tit = '修改开房小吃规则';
								_this.getDetail(row);
								_this.getDetSnack(row.id, 1);
								_this.getDetSnack(row.id, -1);
								_this.showList = false;
								_this.showEdit = true;
							},
							'click .status': function(e, value, row) {
								_this.cgStatus(row.id);
							},
							'click .detail': function(e, value, row) {
								_this.modify = 3;
								_this.edit_tit = '开房小吃规则详情';
								_this.getDetail(row);
								_this.showList = false;
								_this.showEdit = true;
							},
							'click .del': function(e, value, row) {
								layer.confirm("删除后不可恢复，确定删除吗？", {
									btn: ['确定', '取消'],
								}, function() {
									_this.delSnack(row.id);
								});
							}
						},
						formatter: function(value, row, index) {
							let statusText = (row.status == 1) ? '禁用' : '启用';

							let op_html = '';
							$.each(_this.list_menu_op, function(k, v) {
								if(v.name == '状态') {
									op_html += '<span class="'+ v.cls +'">'+ statusText  +'</span>';
								} else {
									op_html += '<span class="'+ v.cls +'">'+ v.name +'</span>';
								}
							});
							return op_html;
						}
					}],
				});
			},
			// 表格数据
			getList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params != "" && params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": $(_this.$refs.snack_shop).val(),
							"room_type": $.trim($(_this.$refs.snack_boxtype).val()),
							"status": $.trim($(_this.$refs.snack_status).val())
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "RoomSnackRule/getList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.count,
								rows: data.response.result.data
							});
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: 0
							});
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 查询
			clkQuery: function() {
				this.innitTable();
			},
			// 禁用/启用
			cgStatus: function(id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "RoomSnackRule/setStatus",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							$(_this.$refs.snack_list).bootstrapTable("refresh");
							layer.msg(data.response.error_msg);
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 删除开房小吃
			delSnack: function(id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "RoomSnackRule/delete",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg('删除成功');
							$(_this.$refs.snack_list).bootstrapTable("refresh");
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 打开新增
			addSnack: function() {
				let  _this = this;

				_this.modify = 1;
				_this.edit_tit = '新增开房小吃规则';
				$(_this.$refs.edit_shop).prop('disabled', false);
				$(_this.$refs.edit_shop).val('').trigger('change');
				$(_this.$refs.edit_priority).prop('disabled', false);
				_this.edit_priority = '';
				// 包厢
				_this.getBoxNum($(_this.$refs.edit_shop).val(), '1');
				$(_this.$refs.edit_box).prop('disabled', false);
				_this.edit_box = '';
				_this.use_all_room = '-1';
				_this.box_item = [];
				// 包厢类型
				$(_this.$refs.edit_boxtype).prop('disabled', false);
				_this.edit_boxtype = '';
				_this.boxtype_item = [];
				_this.getBoxtype($(_this.$refs.edit_shop).val(), '2');
				// 使用时间
				_this.time_start_time = '';
				_this.time_end_time = '';
				// 星期
				let texts = [];
				_this.week_item = [];
				_this.week_arr.forEach(function(item) {
					_this.week_item.push(item.id);
					texts.push(item.name);
				});
				// 开房类型
				_this.oproom_item = ['1'];
				_this.edit_oproom_txt = '计时开房';
				// 小吃
				$(_this.$refs.edit_free).prop('disabled', false);
				_this.edit_free = [];
				$(_this.$refs.free_goods).bootstrapTable("destroy");
				_this.free_goods_arr = [];
				$(_this.$refs.edit_charge).prop('disabled', false);
				_this.edit_charge = [];
				$(_this.$refs.charge_goods).bootstrapTable("destroy");
				_this.charge_goods_arr = [];
				_this.showList = false;
				_this.showEdit = true;
			},
			// 点击选择包厢号
			editBoxFun: function(e) {
				this.c_room_type = this.room_type;
				this.c_box_item = this.box_item;
				this.c_box_all = this.box_all;
				this.showEdit = false;
				this.showBox = true;
			},
			// 包厢号数据
			getBoxNum: function(shop_id, type) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"type": type,
							"shop_id": shop_id
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "Shop/getAllRoomByArea",
					async: false,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							_this.box_arr = data['response']['result'];
							let newarray = [];
							$.each(data['response']['result'], function(k, v) {
								$.each(v.room, function(m, n) {
									newarray.push(n);
								});
							});
							_this.box_arr_det = newarray;
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {}
				});
			},
			// 切换
			boxTypeCg: function(type) {
				let _this = this;

				let temp = this.box_item;
				this.box_item = [];
				$('.snack-box-type li').removeClass('snack-box-sel');
				$('.snack-box-type li').eq(type - 1).addClass('snack-box-sel');
				this.room_type = type;
				this.getBoxNum($(_this.$refs.edit_shop).val(), type);
				this.box_item = temp;
			},
			// 全选
			boxAll: function() {
				let _this = this;
				_this.box_all = _this.c_box_all;
				if(!_this.box_all) { // 实现全选
					_this.box_item = [];
					_this.box_arr_det.forEach(function(item) {
						_this.box_item.push(item.id);
					});
				} else { // 实现反选
					_this.box_item = [];
				}
			},
			// 楼层全选/反选
			boxFloor: function(id, index) {
				let _this = this;

				_this.box_floor = _this.c_box_floor;
				if(_this.box_floor.indexOf(id) == -1) {
					$.each(_this.box_arr[index].room, function(k, v) {
						if(_this.box_item.indexOf(v.id) == -1) {
							_this.box_item.push(v.id);
						}
					});
				} else {
					$.each(_this.box_arr[index].room, function(k, v) {
						let index = '';
						index = _this.box_item.indexOf(v.id);
						if(index != -1) {
							_this.box_item.splice(index, 1);
						}
					});
				}
			},
			// 确定包厢
			saveBox: function() {
				var _this = this;

				if(_this.box_all) {
					_this.edit_box = '全部包厢';
					_this.use_all_room = '1';
				} else {
					let texts = [];
					_this.box_arr_det.forEach(function(item) {
						_this.box_item.forEach(function(sub) {
							if(item.id == sub) {
								texts.push(item.name);
							}
						});
					});
					_this.edit_box = texts.join(",");
					_this.use_all_room = '-1';
				}
				_this.showEdit = true;
				_this.showBox = false;
			},
			// 返回
			boxBackEdit: function() {
				let _this = this;
				this.room_type = this.c_room_type;
				this.box_item = this.c_box_item;
				$('.snack-box-type li').removeClass('snack-box-sel');
				$('.snack-box-type li').eq(this.room_type - 1).addClass('snack-box-sel');
				this.getBoxNum($(_this.$refs.edit_shop).val(), _this.room_type);
				this.showEdit = true;
				this.showBox = false;
			},
			// 点击包厢类型
			editBoxtypeFun: function() {
				let _this = this;

				let c_boxtype_item = _this.boxtype_item;
				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: ['包厢类型', true],
					area: ['600px', ''], // 宽高
					content: $(_this.$refs.boxtype_alert),
					cancel: function() {
						// 右上角关闭
						if(_this.edit_boxtype != "") {
							_this.boxtype_item = c_boxtype_item;
							return;
						}
						_this.boxtype_item = [];
					}
				}, function() {
					let texts = [];
					_this.boxtype_arr.forEach(function(item) {
						_this.boxtype_item.forEach(function(item2) {
							if(item.id == item2){
								texts.push(item.name);
							}
						});
					});
					_this.edit_boxtype = texts.join(",");
					layer.closeAll();
				}, function() {
					if(_this.edit_boxtype != "") {
						_this.boxtype_item = c_boxtype_item;
						return;
					}
					_this.boxtype_item = [];
				});
			},
			// 全选
			boxtypeAll: function() {
				let _this = this;

				_this.boxtype_all = _this.c_boxtype_all;
				if(!_this.boxtype_all) { // 实现全选
					_this.boxtype_item = [];
					_this.boxtype_arr.forEach(function(item) {
						_this.boxtype_item.push(item.id);
					});
				} else { // 实现反选
					_this.boxtype_item = [];
				}
			},
			// 点击选择时间
			useTimePop: function() {
				let _this = this;
				if(_this.time_start_time != '') {
					$(_this.$refs.starthour).val(_this.time_start_time.split(':')[0]).trigger('change');
					$(_this.$refs.startseconds).val(_this.time_start_time.split(':')[1]).trigger('change');
					$(_this.$refs.stophour).val(_this.time_end_time.split(':')[0]).trigger('change');
					$(_this.$refs.stopseconds).val(_this.time_end_time.split(':')[1]).trigger('change');
				} else {
					$(_this.$refs.starthour).val('').trigger('change');
					$(_this.$refs.startseconds).val('').trigger('change');
					$(_this.$refs.stophour).val('').trigger('change');
					$(_this.$refs.stopseconds).val('').trigger('change');
				}
				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: '使用时间选择',
					area: ['450px', ''], // 宽高
					content: $(_this.$refs.snack_use_time)
				}, function() {
					_this.createTimeString();
					layer.closeAll();
				});
			},
			// 获取选择的时间
			createTimeString() {
				let _this = this;
				let starthour = $(_this.$refs.starthour).select2("val");
				let startseconds = $(_this.$refs.startseconds).select2("val");
				let stophour = $(_this.$refs.stophour).select2("val");
				let stopseconds = $(_this.$refs.stopseconds).select2("val");
				_this.time_start_time = starthour + ":" + startseconds;
				_this.time_end_time = stophour + ":" + stopseconds;
			},
			// 获取时间
			selectTime: function() {
				let _this = this;
				let seconds = [];
				for(let i = 0; i < 60; i++) {
					let item = {};
					item.id = (i < 10) ? '0' + i : i;
					item.text = (i < 10) ? '0' + i : i;
					seconds[i] = item;
				};
				let hour = [];
				for(let i = 0; i < 24; i++) {
					let item = {};
					item.id = (i < 10) ? '0' + i : i;
					item.text = (i < 10) ? '0' + i : i;
					hour[i] = item;
				}
				$(_this.$refs.starthour).select2({
					data: hour,
					language: "zh-CN"
				});
				$(_this.$refs.startseconds).select2({
					data: seconds,
					language: "zh-CN"
				});
				$(_this.$refs.stophour).select2({
					data: hour,
					language: "zh-CN"
				});
				$(_this.$refs.stopseconds).select2({
					data: seconds,
					language: "zh-CN"
				})
			},
			// 选择星期
			editWeekFun: function() {
				let _this = this;
				let c_week_item = _this.week_item;
				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: ['有效星期几', true],
					area: ['450px', ''], // 宽高
					content: $(_this.$refs.week_alert),
					cancel: function() {
						// 右上角关闭
						if(_this.edit_week_txt != "") {
							_this.week_item = c_week_item;
							return;
						}
						_this.week_item = [];
					}
				}, function() {
					let texts = [];
					_this.week_arr.forEach(function(item) {
						_this.week_item.forEach(function(item2) {
							if(item.id == item2) {
								texts.push(item.name);
							}
						});
					});
					_this.edit_week_txt = texts.join(",");
					layer.closeAll();
				}, function() {
					if(_this.edit_week_txt != "") {
						_this.week_item = c_week_item;
						return;
					}
					_this.week_item = [];
				});
			},
			// 全选
			weekAll: function() {
				let _this = this;
				_this.week_all = _this.c_week_all;
				if(!_this.week_all) { // 实现全选
					_this.week_item = [];
					_this.week_arr.forEach(function(item) {
						_this.week_item.push(item.id);
					});
				} else { // 实现反选
					_this.week_item = [];
				}
			},
			// 选择开房类型
			editOproomFun: function() {
				let _this = this;
				let c_oproom_item = _this.oproom_item;
				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: ['开房类型', true],
					area: ['550px', ''], // 宽高
					content: $(_this.$refs.oproom_alert),
					cancel: function() {
						// 右上角关闭
						if(_this.edit_oproom_txt != "") {
							_this.oproom_item = c_oproom_item;
							return;
						}
						_this.oproom_item = [];
					}
				}, function() {
					let texts = [];
					_this.oproom_arr.forEach(function(item) {
						_this.oproom_item.forEach(function(item2) {
							if(item.id == item2) {
								texts.push(item.name);
							}
						});
					});
					_this.edit_oproom_txt = texts.join(",");
					layer.closeAll();
				}, function() {
					if(_this.edit_oproom_txt != "") {
						_this.oproom_item = c_oproom_item;
						return;
					}
					_this.oproom_item = [];
				});
			},
			// 全选
			oproomAll: function() {
				let _this = this;
				_this.oproom_all = _this.c_oproom_all;
				if(!_this.oproom_all) { // 实现全选
					_this.oproom_item = [];
					_this.oproom_arr.forEach(function(item) {
						_this.oproom_item.push(item.id);
					});
				} else { // 实现反选
					_this.oproom_item = [];
				}
			},




			// 点击选择免费小吃
			editFreeFun: function() {
				this.showFree = true;
				this.showEdit = false;
			},
			// 点击“添加商品”
			addFreeGoods: function() {
				let _this = this;
				$(_this.$refs.free_goods_type).val('').trigger('change');
				_this.free_sign = '';
				_this.initFreeGoods($(_this.$refs.edit_shop).val());
				layer.open({
					type: 1,
					title: '添加商品',
					skin: 'layui-layer-rim', // 加上边框
					area: ['700px', '550px'], // 宽高
					content: $(_this.$refs.free_goods_alert)
				});
			},
			// 初始化免费小吃的商品列表
			initFreeGoods: function(shop_id) {
				let _this = this;
				$(_this.$refs.free_goods_list).bootstrapTable('destroy');
				$(_this.$refs.free_goods_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getGoodsList(params, shop_id);
					},
					sidePagination: "server",
					columns: [{
						checkbox: true,
						title: "全选"
					}, {
						field: "goods_type_name",
						title: "类型"
					}, {
						field: "goods_name",
						title: "名称"
					}, {
						field: "goods_unit_name",
						title: "单位"
					}],
					clickToSelect: true
				});
			},
			// 获取商品列表
			getGoodsList: function(params, shop_id) {
				let _this = this,
					goods_type = $(_this.$refs.free_goods_type).val(),
					goods_name = $(_this.$refs.free_goods_name).val(),
					pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": shop_id,
							"goods_type": goods_type,
							"goods_name": goods_name,
							"status": '1'
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 初始化商品套餐列表
			initFreePackage: function(shop_id) {
				let _this = this;
				$(_this.$refs.free_goods_list).bootstrapTable('destroy');
				$(_this.$refs.free_goods_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getGoodsPackageList(params, shop_id);
					},
					sidePagination: "server",
					columns: [{
						checkbox: true,
						title: "全选"
					}, {
						field: "goods_type_name",
						title: "类型",
						formatter: function(value, row, index) {
							return '商品套餐'
						}
					}, {
						field: "name",
						title: "名称"
					}, {
						field: "package_unit_name",
						title: "单位"
					}],
					clickToSelect: true
				});
			},
			// 获取商品套餐列表
			getGoodsPackageList: function(params, shop_id) {
				let _this = this,
					pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": shop_id,
							"goods_type": _this.free_sign_id,
							"goods_name": $(_this.$refs.free_goods_name).val(),
							"status": '1'
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsPackage",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 点击添加商品弹窗的“查询”按钮
			queryFreeGoods: function() {
				if(this.free_sign == '-2') {
					this.initFreePackage($(this.$refs.edit_shop).val());
				} else {
					this.initFreeGoods($(this.$refs.edit_shop).val());
				}
			},
			// 点击免费小吃商品弹窗的“保存”按钮
			saveFreeGoods: function() {
				let _this = this;
				$.map($(_this.$refs.free_goods_list).bootstrapTable('getSelections'), function(row) {
					for(let i = 0; i < _this.free_goods_arr.length; i++) {
						if(_this.free_goods_arr[i].goods_id == row.id) {
							layer.msg("商品已存在");
							return;
						}
					}
					if(_this.free_sign == '-2') {
						_this.free_goods_arr.push({ goods_id: row.id, goods_name: row.name, goods_type: '0', goods_type_name: '商品套餐', good_img: row.img_url, goods_unit: row.package_unit, goods_unit_name: row.package_unit_name, is_free: '1', quantity: '', status: '1' });
					} else {
						_this.free_goods_arr.push({ goods_id: row.id, goods_name: row.goods_name, goods_type: row.goods_type, goods_type_name: row.goods_type_name, good_img: row.good_img, goods_unit: row.package_unit, goods_unit_name: row.goods_unit_name, is_free: '1', quantity: '', status: '' });
					}
					layer.msg("成功添加商品");
				});
				$(_this.$refs.free_goods).bootstrapTable("destroy");
				_this.initRightGoods();
			},
			// 初始化免费小吃商品表格
			initRightGoods: function() {
				let _this = this;
				$(_this.$refs.free_goods).bootstrapTable({
					pageNumber: 1,
					pageSize: 10,
					pageList: [],
					pagination: true,
					columns: [{
						field: "goods_type_name",
						title: "商品类型",
						width: "10%",
						valign: "middle"
					}, {
						field: "good_img",
						title: "商品图片",
						width: "15%",
						valign: "middle",
						formatter: function(value, row, index) {
							return '<img src="'+ row.good_img +'" class="good-img" />'
						}
					}, {
						field: "goods_name",
						title: "商品名称",
						width: "15%",
						valign: "middle"
					}, {
						field: "goods_unit_name",
						title: "商品单位",
						width: "10%",
						valign: "middle"
					}, {
						field: "quantity",
						title: "数量",
						width: "10%",
						valign: "middle",
						events: {
							'blur .good-num': function (e, value, row, index) {
								if($.trim($(this).val()) > 0) {
									_this.free_goods_arr[index] = {
										"goods_id": row.goods_id,
										"goods_name": row.goods_name,
										"goods_type": row.goods_type,
										"goods_type_name": row.goods_type_name,
										"good_img": row.good_img,
										"goods_unit": row.package_unit,
										"goods_unit_name": row.goods_unit_name,
										"is_free": '1',
										"status": row.status,
										"quantity": $.trim($(this).val())
									};
								} else {
									layer.msg('商品数量需要大于0');
								}
							}
						},
						formatter: function(value, row, index) {
							return [
								'<input type="text" placeholder="请输入数量" class="good-num" value="'+ row.quantity +'" />'
							].join('');
						}
					}, {
						field: "price",
						title: "金额",
						width: "10%",
						valign: "middle",
						formatter: function(value, row, index) {
							return '免费';
						}
					}, {
						field: "op",
						title: "操作",
						width: "10%",
						valign: "middle",
						events: {
							'click .delete': function(e, value, row, index) {
								layer.confirm("确定删除该商品吗？", {
									btn: ['确定', '取消'], //按钮
								}, function() {
									let depositeData = [];
									for(let i = 0; i < _this.free_goods_arr.length; i++) {
										if(_this.free_goods_arr[i].goods_id != row.goods_id) {
											depositeData.push(_this.free_goods_arr[i]);
										}
									}
									_this.free_goods_arr = depositeData;
									$(_this.$refs.free_goods).bootstrapTable("destroy");
									_this.initRightGoods();
									layer.closeAll();
								});
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-blue delete">删除</span>'
						}
					}],
					data: _this.free_goods_arr
				});
			},
			// 确定免费小吃
			saveFree: function() {
				let _this = this;
				_this.edit_free = [];
				if(_this.free_goods_arr.length == 0) {
					_this.showFree = false;
					_this.showEdit = true;
				} else {
					$.each(_this.free_goods_arr, function(k, v) {
						_this.edit_free.push(v.goods_name);
						if(_this.free_goods_arr[k].quantity < 1) {
							layer.msg('商品数量需要大于0');
							return false;
						} else if(k < _this.free_goods_arr.length - 1) {
							return;
						} else {
							_this.showFree = false;
							_this.showEdit = true;
						}
					});
				}
			},
			// 关闭弹窗
			closelayer: function() {
				layer.closeAll();
			},

			// 点击选择收费小吃
			editChargeFun: function() {
				this.showEdit = false;
				this.showCharge = true;
			},
			// 点击添加收费小吃
			addChargeGoods: function() {
				var _this = this;
				$(_this.$refs.charge_goods_type).val('').trigger('change');
				_this.charge_sign = '';
				_this.initChargeGoods($(_this.$refs.edit_shop).val());
				layer.open({
					type: 1,
					title: '添加商品',
					skin: 'layui-layer-rim', //加上边框
					area: ['700px', '550px'], //宽高
					content: $(_this.$refs.charge_goods_alert)
				});
			},
			// 初始化收费小吃的商品列表
			initChargeGoods: function(shop_id) {
				let _this = this;
				$(_this.$refs.charge_goods_list).bootstrapTable('destroy');
				$(_this.$refs.charge_goods_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getDistbGoodsList(params, shop_id);
					},
					sidePagination: "server",
					columns: [{
						checkbox: true,
						title: "全选"
					}, {
						field: "goods_type_name",
						title: "类型"
					}, {
						field: "goods_name",
						title: "名称"
					}, {
						field: "goods_unit_name",
						title: "单位"
					}],
					clickToSelect: true
				});
			},
			getDistbGoodsList: function(params, shop_id) {
				let _this = this,
					goods_type = $(_this.$refs.charge_goods_type).val(),
					goods_name = $(_this.$refs.charge_goods_name).val(),
					pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": shop_id,
							"goods_type": goods_type,
							"goods_name": goods_name,
							"status": '1'
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},

			// 初始化商品套餐列表
			initChargePackage: function(shop_id) {
				let _this = this;
				$(_this.$refs.charge_goods_list).bootstrapTable('destroy');
				$(_this.$refs.charge_goods_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getDistbGoodsPackageList(params, shop_id);
					},
					sidePagination: "server",
					columns: [{
						checkbox: true,
						title: "全选"
					}, {
						field: "goods_type_name",
						title: "类型",
						formatter: function(value, row, index) {
							return '商品套餐'
						}
					}, {
						field: "name",
						title: "名称"
					}, {
						field: "package_unit_name",
						title: "单位"
					}],
					clickToSelect: true
				});
			},
			// 获取商品套餐列表
			getDistbGoodsPackageList: function(params, shop_id) {
				let _this = this,
					pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": shop_id,
							"goods_type": _this.charge_sign_id,
							"goods_name": $(_this.$refs.charge_goods_name).val(),
							"status": '1'
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsPackage",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 点击添加商品弹窗的“查询”按钮
			queryChargeGoods: function() {
				if(this.charge_sign == '-2') {
					this.initChargePackage($(this.$refs.edit_shop).val());
				} else {
					this.initChargeGoods($(this.$refs.edit_shop).val());
				}
			},

			// 点击收费小吃商品弹窗的“保存”按钮
			saveChargeGoods: function() {
				let _this = this;
				$.map($(_this.$refs.charge_goods_list).bootstrapTable('getSelections'), function(row) {
					for(let i = 0; i < _this.charge_goods_arr.length; i++) {
						if(_this.charge_goods_arr[i].goods_id == row.id) {
							layer.msg("商品已存在");
							return;
						}
					}

					if(_this.charge_sign == '-2') {
						_this.charge_goods_arr.push({ goods_id: row.id, goods_name: row.name, goods_type: '0', goods_type_name: '商品套餐', good_img: row.img_url, goods_unit: row.package_unit, goods_unit_name: row.package_unit_name, is_free: '-1', quantity: '', actual_price: '', price: row.actual_price, amount: 0, status: '1' });
					} else {
						_this.charge_goods_arr.push({ goods_id: row.id, goods_name: row.goods_name, goods_type: row.goods_type, goods_type_name: row.goods_type_name, good_img: row.good_img, goods_unit: row.package_unit, goods_unit_name: row.goods_unit_name, is_free: '-1', quantity: '', actual_price: '',  price: row.discount_price, amount: 0 });
					}
					layer.msg("成功添加商品");
				});
				_this.initDistbGoods();
			},
			// 初始化收费小吃的商品表格
			initDistbGoods: function() {
				let _this = this;
				$(_this.$refs.charge_goods).bootstrapTable("destroy");
				$(_this.$refs.charge_goods).bootstrapTable({
					pageNumber: 1,
					pageSize: 10,
					pageList: [],
					pagination: true,
					columns: [{
						field: "goods_type_name",
						title: "商品类型",
						width: "8%",
						valign: "middle"
					}, {
						field: "good_img",
						title: "商品图片",
						width: "10%",
						valign: "middle",
						formatter: function(value, row, index) {
							return '<img src="'+ row.good_img +'" class="good-img" />'
						}
					}, {
						field: "goods_name",
						title: "商品名称",
						width: "15%",
						valign: "middle"
					}, {
						field: "goods_unit_name",
						title: "商品单位",
						width: "8%",
						valign: "middle"
					}, {
						field: "quantity",
						title: "数量",
						width: "8%",
						valign: "middle",
						events: {
							'blur .distb-good-num': function (e, value, row, index) {
								if($.trim($(this).val()) > 0) {
									_this.charge_goods_arr[index].quantity = $.trim($(this).val());
									if(row.actual_price != '') {
										_this.charge_goods_arr[index].amount = $.trim($(this).val()) * row.actual_price;
									} else {
										_this.charge_goods_arr[index].amount = $.trim($(this).val()) * row.price;
									}
								} else {
									layer.msg('商品数量需要大于0');
									_this.charge_goods_arr[index].quantity = '';
									_this.charge_goods_arr[index].amount = 0;
								}

								// 刷新滚动条不变
								let scollPostion = $('.tab-content').scrollTop();
								$(_this.$refs.charge_goods).bootstrapTable('refreshOptions', {});
								$('.tab-content').scrollTop(scollPostion);
							}
						},
						formatter: function(value, row, index) {
							return [
								'<input type="text" placeholder="请输入数量" class="distb-good-num" value="'+ row.quantity +'" />'
							].join('');
						}
					}, {
						field: "actual_price",
						title: "手动价",
						width: "10%",
						valign: "middle",
						events: {
							'click .editableicon': function(e, value, row, index) {
								$(this).prev().addClass("editableinput-focus");
								$(this).prev().attr("contenteditable", true);
								$(this).addClass("editableiconend");
								// $(this).prev().focus();
							},
							'blur .actual-price': function(e, value, row, index) {
								$(this).removeClass("editableinput-focus");
								$(this).attr("contenteditable", false);
								$(this).next().removeClass("editableiconend");
								if($.trim($(this).text()) < 0) {
									layer.msg('手动价需要大于等于0');
									_this.charge_goods_arr[index].actual_price = '';
								} else if($.trim($(this).text()) == '') {
									_this.charge_goods_arr[index].actual_price = '';
									_this.charge_goods_arr[index].amount = row.quantity * row.price;
								} else {
									_this.charge_goods_arr[index].actual_price = $.trim($(this).text());
									_this.charge_goods_arr[index].amount = $.trim($(this).text()) * row.quantity;
								}

								// 刷新滚动条不变
								let scollPostion = $('.tab-content').scrollTop();
								$(_this.$refs.charge_goods).bootstrapTable('refreshOptions', {});
								$('.tab-content').scrollTop(scollPostion);
							},
						},
						formatter: function(value, row, index) {
							return '<div class="editableinput actual-price" contenteditable="false">' + value + '</div><a class="editableicon"></a>';
						}
					}, {
						field: "price",
						title: "单价",
						width: "8%",
						valign: "middle"
					}, {
						field: "amount",
						title: "金额",
						width: "8%",
						valign: "middle"
					}, {
						field: "op",
						title: "操作",
						width: "8%",
						valign: "middle",
						events: {
							'click .delete': function(e, value, row, index) {
								layer.confirm("确定删除该商品吗？", {
									btn: ['确定', '取消'], //按钮
								}, function() {
									let depositeData = [];
									for(let i = 0; i < _this.charge_goods_arr.length; i++) {
										if(_this.charge_goods_arr[i].goods_id != row.goods_id) {
											depositeData.push(_this.charge_goods_arr[i]);
										}
									}
									_this.charge_goods_arr = depositeData;
									_this.initDistbGoods();
									layer.closeAll();
								});
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-blue delete">删除</span>'
						}
					}],
					data: _this.charge_goods_arr
				});
			},
			// 确定收费小吃商品
			saveCharge: function() {
				let _this = this;
				_this.edit_charge = [];
				if(_this.charge_goods_arr.length == 0) {
					_this.showCharge = false;
					_this.showEdit = true;
				} else {
					$.each(_this.charge_goods_arr, function(k, v) {
						_this.edit_charge.push(v.goods_name);
						if(_this.charge_goods_arr[k].quantity < 1) {
							layer.msg('商品数量需要大于0');
						} else if(k < _this.charge_goods_arr.length - 1) {
							return;
						} else {
							_this.showCharge = false;
							_this.showEdit = true;
						}
					});
				}
			},
			
			// 返回列表页
			backList: function() {
				this.showEdit = false;
				this.showDetail = false;
				this.showList = true;
			},
			// 新增/修改开房小吃规则
			saveEdit: function() {
				let _this = this;
				let use_all_room_type = '-1',
					goods_info = [];
				if(_this.box_item == '' && _this.boxtype_item == '') {
					layer.msg('请选择适用包厢或包厢类型');
					return;
				}
				if(_this.boxtype_all) {
					use_all_room_type = '1';
				} else {
					use_all_room_type = '-1';
				}
				goods_info = _this.free_goods_arr.concat(_this.charge_goods_arr);
				let datas;
				if(_this.modify == "1") {
					datas = {
						"header": Vue.request_header,
						"request": {
							"param": {
								"shop_id": $(_this.$refs.edit_shop).val(), // 门店id
								"listorder": _this.edit_priority, // 优先级
								"use_all_room": _this.use_all_room,
								"room_ids": _this.box_item,
								"use_all_room_type": use_all_room_type,
								"room_types": _this.boxtype_item,
								"start_time": _this.time_start_time,
								"end_time": _this.time_end_time,
								"week_cycle": _this.week_item,
								"type": _this.oproom_item,
								"goods_info": goods_info
							}
						},
						"comment": ""
					};
				} else {
					datas = {
						"header": Vue.request_header,
						"request": {
							"param": {
								"id": _this.edit_id,
								"shop_id": $(_this.$refs.edit_shop).val(), // 门店id
								"listorder": _this.edit_priority, // 优先级
								"use_all_room": _this.use_all_room,
								"room_ids": _this.box_item,
								"use_all_room_type": use_all_room_type,
								"room_types": _this.boxtype_item,
								"start_time": _this.time_start_time,
								"end_time": _this.time_end_time,
								"week_cycle": _this.week_item,
								"type": _this.oproom_item,
								"goods_info": goods_info
                            }
                        },
                        "comment": ""
                    };
                }
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "RoomSnackRule/editRule",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            layer.msg(data["response"]["error_msg"]);
                            $(_this.$refs.snack_list).bootstrapTable('refresh');

                            _this.showEdit = false;
                            _this.showList = true;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {

                    }
                });
			},

			// 详情
			getDetail: function(row) {
				let _this = this;

				_this.edit_id = row.id;
				$(_this.$refs.edit_shop).val(row.shop_id).trigger('change');
				$(_this.$refs.edit_shop).prop('disabled', true);
				_this.edit_priority = row.listorder;

				// 适用包厢
				_this.getBoxNum($(_this.$refs.edit_shop).val(), 1);
				if(row.use_all_room == '1') {
					_this.edit_box = '全部包厢';
					// _this.box_all = ['0']
					_this.box_arr_det.forEach(function(item) {
						_this.box_item.push(item.id);
					});
				} else {
					if(row.room_info == '无') {
						_this.edit_box = '';
						$(_this.$refs.edit_boxtype).prop("disabled", false);
					} else {
						_this.edit_box = row.room_info;
						$(_this.$refs.edit_boxtype).prop("disabled", true);
					}
					_this.box_item = row.room_ids;
				}
				_this.use_all_room = row.use_all_room;

				if(row.room_type_info == '无') {
					_this.edit_boxtype = '';
					$(_this.$refs.edit_box).prop("disabled", false);
				} else {
					_this.edit_boxtype = row.room_type_info;
					$(_this.$refs.edit_box).prop("disabled", true);
				}
				_this.getBoxtype(row.shop_id, 2);
				_this.boxtype_item = row.room_types;
				_this.time_start_time = row.start_time;
				_this.time_end_time = row.end_time;
				_this.edit_week_txt = row.week_cycle_name;
				_this.week_item = row.week_cycle;
				_this.edit_oproom_txt = row.type_names.join(',');
				_this.oproom_item = row.type;
				_this.edit_free = row.free_snack_info;
				_this.edit_charge = row.charge_snack_info;

				if(_this.modify == 2) {
					$(_this.$refs.edit_priority).prop('disabled', false);
					$(_this.$refs.edit_use_time).prop('disabled', false);
					$(_this.$refs.edit_free).prop('disabled', false);
					$(_this.$refs.edit_charge).prop('disabled', false);
				} else {
					$(_this.$refs.edit_priority).prop('disabled', true);
					$(_this.$refs.edit_box).prop('disabled', true);
					$(_this.$refs.edit_boxtype).prop('disabled', true);
					$(_this.$refs.edit_use_time).prop('disabled', true);
					$(_this.$refs.edit_free).prop('disabled', true);
					$(_this.$refs.edit_charge).prop('disabled', true);
				}
			},
			// 小吃详情
			getDetSnack: function(id, is_free) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"id": id,
							"is_free": is_free
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "RoomSnackRule/getDetail",
					async: false,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							if(is_free == '1') {
								_this.free_goods_arr = data.response.result;
								$(_this.$refs.free_goods).bootstrapTable("destroy");
								_this.initRightGoods();
							} else {
								_this.charge_goods_arr = data.response.result;
								_this.initDistbGoods();
							}
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {}
				});
			},

		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.commodity-snack {
		table {
			table-layout: fixed;
			word-wrap: break-word;
		}
	}
	.snack-box-page {
		.snack-box-type {
			margin: 30px 0;
			li {
				float: left;
				width: 130px;
				height: 40px;
				border: 1px solid #CCC;
				margin: 0 30px 0 0;
				line-height: 40px;
				color: #CCC;
				text-align: center;
				cursor: pointer;
			}
			.snack-box-sel {
				border: 1px solid #009af0;
				color: #FFF;
				background: #009af0;
			}
		}
	}
	.free-page {
		.free-page-txt {
			margin: 20px 0 0;
			text-align: center;
			font-size: 14px;
		}
		.good-img {
			display: block;
			width: 50px;
			margin: 0 auto;
		}
		.delete {
			cursor: pointer;
		}
	}
	.free-goods-alert, .charge-goods-alert {
		width: 100%;
		height: 100%;
		padding: 20px 30px;
		display: none;
		#good-name {
			border: 1px solid #FF6700;
		}
		.btns {
			margin-top: 10px;
			position: absolute;
			bottom: 30px;
			#pop-save {
				margin-left: 140px;
			}
		}
	}
	.charge-page {
		h3 {
			margin: 30px 0;
			text-align: center;
		}
		p {
			color: #FF0707;
		}
		img {
			display: block;
			width: 50px;
			margin: 0 auto;
		}
	}
</style>